import { Injectable } from '@angular/core';
import { AppleApplication, SyncCurrentlyConfiguredService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, mergeMap } from 'rxjs';
import {
  ConfiguredApplicationsResolverActions,
  ConfiguredApplicationsApiActions,
} from './device-configured-applications.actions';
import { safeMap } from '@era/stores';

@Injectable()
export class DeviceConfiguredApplicationsEffects {
  constructor(
    private readonly service: SyncCurrentlyConfiguredService,
    private readonly actions$: Actions
  ) {}

  // TODO: We should have an alternative working solution to show the pause icon
  // requestApplicationsForDeviceEffect$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(DeviceActionTypes.DEVICE_API_DEVICES_LOADED),
  //     mergeMap((action: DeviceApiDevicesLoaded) => {
  //       const ids = action.payload.devices.map((x) => x.deviceId);
  //       return of(ConfiguredApplicationsResolverActions.configuredApplicationsRequested({ deviceIds: ids }));
  //     })
  //   )
  // );

  deviceConfiguredApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ConfiguredApplicationsResolverActions.configuredApplicationsRequested),
      mergeMap(({ deviceIds }) => {
        const requests = deviceIds.map((deviceId) =>
          safeMap(
            this.service.getCurrentApplications(deviceId),
            (configuredApplications: AppleApplication[]) => {
              const mapped = configuredApplications.map((x) => {
                return { deviceId: deviceId, ...x };
              });

              return ConfiguredApplicationsApiActions.configuredApplicationsLoaded({ configuredApplications: mapped });
            },
            (error) => ConfiguredApplicationsApiActions.configuredApplicationsLoadedError({ error })
          )
        );

        return forkJoin(requests).pipe(mergeMap((x) => x));
      })
    );
  });
}
